import { SquadWelcomeDialog } from '#src/components/squad/SquadWelcomeDialog/index.tsx';

const SquadPage = () => {
  return <SquadWelcomeDialog />;
};
export default SquadPage;
